module.exports = __webpack_public_path__ + "assets/news.8cccf668.svg";